import React from 'react'

import {
  formatKubernetesParams,
  generateKubernetesSelectionOptions
} from 'components/attacks/create/targets/kubernetes/kubernetes-target-utils'

// Reusable code to format k8s data for attack targeting
export function useFormattedK8sTargeting(targets) {
  return React.useMemo(() => {
    const targetsByOwners = generateKubernetesSelectionOptions(targets)
    const { labelKeys, availableTargetParams } =
      formatKubernetesParams(targetsByOwners)
    return {
      labelKeys,
      availableTargetParams,
      targetsByOwners
    }
  }, [targets])
}
